/**
 * DateTimePicker
 * Themed date/time input control.
 */

import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { DARK_THEME } from '@/presentation/theme/theme';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

interface DateTimePickerProps {
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  /** Optional `data-qa-*` set for the `<input type="datetime-local">` so the qa-tester can locate it. */
  qa?: QaAttrOptions;
}

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  onChange,
  min,
  max,
  qa,
}) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <input
      {...(qa ? qaAttr(qa) : {})}
      type="datetime-local"
      value={value}
      min={min}
      max={max}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: '100%',
        padding: responsive.spacing.base,
        fontSize: responsive.font.base,
        color: theme.text.primary,
        backgroundColor: theme.surface,
        border: `${responsive.border.thin}px solid ${theme.border}`,
        borderRadius: responsive.borderRadius.base,
        outline: 'none',
        colorScheme: theme === DARK_THEME ? 'dark' : 'light',
      }}
    />
  );
};
